/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class ETransportNomenclatureVO extends JSONable {
  uuid: string | null = null;
  code: string | null = null;
  label: string | null = null;
}
